





































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import Role from '@/store/entities/role';
    @Component
    export default class CreateRole extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        role:Role=new Role();
        get permissions(){
            return this.$store.state.role.permissions
        }
	    permissionData:any = [
		    {
			    title:'所有',
			    value:1,
			    selected:false,
			    checked:false,
			    expand:true,
			    children:[]
		    }
	    ]
        save(){
            (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
                if(valid){
	                this.role.permissions=[];
	                //遍历树节点
	                this.permissionData[0].children.forEach((item:any,index:any)=>{
		                if(item.checked){

			                this.role.permissions.push(item.value)
		                }
		                item.children.forEach((item_c:any)=>{
			                if(item_c.checked){
				                this.role.permissions.push(item_c.value)
			                }
		                })
	                })
	                let res = await this.$store.dispatch({
		                type:'role/create',
		                data:this.role
	                });
	                // this.$Message.success(res.message)
	                if(res.success){
		                this.$Message.success('新增成功');
		                (this.$refs.roleForm as any).resetFields();
		                this.$emit('save-success');
		                this.$emit('input',false);
	                }
                }
            })
        }
        created(){
	        this.getpermissions()
        }
        cancel(){
            (this.$refs.roleForm as any).resetFields();
            this.$emit('input',false);
        }
	    async getpermissions(){
		    let data = await this.$store.dispatch({
			    type:'role/getPermissions'
		    })
		    // let data = this.$store.state.role.permissions;
		    // console.log(data)
		    if(data){
			    data.forEach((item:any,index:any) => {
				    this.permissionData[0].children.push({
					    title:item.displayName,
					    value:item.name,
					    selected:false,
					    expand:false,
					    checked:false,
					    children:[]
				    })
				    item.children.forEach((item_c:any) => {
					    this.permissionData[0].children[index].children.push({
						    title:item_c.displayName,
						    value:item_c.name,
						    selected:false,
						    expand:false,
						    checked:false,
					    })
				    });
			    });
		    }
	    }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }
        }
        roleRule={
            name:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('RoleName')),trigger: 'blur'}],
            displayName:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('DisplayName')),trigger: 'blur'}]
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/role/create-role.vue